module.exports = "<packages-page></packages-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appPlans/packages.html
// module id = 2021
// module chunks = 0